/* eslint-disable */
export default {
  download: 'Transferir',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
